


















import { Vue, Component, Prop } from 'vue-property-decorator';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';
import RdStation from '@/plugins/api/RdStation';
import Simulador from '@/plugins/api/Simulador';
import Indicadores from '@/plugins/api/Indicadores';
import DataLayer from '@/plugins/DataLayer';
import OriginalOrigem from '@/plugins/OriginalOrigem';
import { showErroCotacao } from '@/utils/showErroCotacao';

@Component({
  components: { ChevronDoubleRightIcon },
})
export default class DadosProsseguir extends Vue {
  @Prop({ default: false }) public readonly valid!: boolean;

  public loadingCotacao = false;

  get cotacao() {
    return this.$store.state.cotacao;
  }

  get loadingFipe() {
    return this.$store.state.loading_fipe;
  }

  get textButton() {
    if (this.cotacao.origem_fipe) {
      return 'Calcular Valor da Proteção';
    } else if (this.$route.name === 'dados') {
      return 'Ver o valor da Proteção';
    } else if (this.$route.name === 'cliente') {
      return 'Continuar';
    } else if (this.$route.name === 'veiculo') {
      return 'Ver o valor da Proteção';
    }
  }

  get nextRoute() {
    if (this.$route.name === 'cliente') {
      return 'veiculo';
    } else {
      return 'detalhes';
    }
  }

  get nextUrl() {
    if (this.cotacao.valor_fipe > 100000) {
      return 'acima100';
    }
    return 'abaixo100';
  }

  get nextQuery() {
    const query = {} as { ref: string; id: string };
    if (this.cotacao.cod_indicador !== 0) {
      query.ref = this.cotacao.cod_indicador as string;
    }
    if (this.cotacao.protocolo) {
      query.id = `${this.cotacao.protocolo}`;
    }
    return query;
  }

  get email() {
    return this.$store.getters.get_email;
  }

  get dddTelefone() {
    return `${this.cotacao.ddd}${this.cotacao.telefone}`;
  }

  get dados(): { [key: string]: any } {
    const query = this.$route.query;
    const utms: { [key: string]: string } = {};

    if (typeof query.utm_source === 'string' && query.utm_source) {
      utms.utm_source = query.utm_source;
    }
    if (typeof query.utm_medium === 'string' && query.utm_medium) {
      utms.utm_medium = query.utm_medium;
    }
    if (typeof query.utm_campaign === 'string' && query.utm_campaign) {
      utms.utm_campaign = query.utm_campaign;
    }
    if (typeof query.utm_content === 'string' && query.utm_content) {
      utms.utm_content = query.utm_content;
    }
    if (typeof query.utm_term === 'string' && query.utm_term) {
      utms.utm_term = query.utm_term;
    }
    if (typeof query.fbclid === 'string' && query.fbclid) {
      utms.fbclid = query.fbclid;
    }
    if (typeof query.gclid === 'string' && query.gclid) {
      utms.gclid = query.gclid;
    }
    if (typeof query.fbc === 'string' && query.fbc) {
      utms.fbc = query.fbc;
    }
    if (typeof query.fbp === 'string' && query.fbp) {
      utms.fbp = query.fbp;
    }
    if (typeof query.src === 'string' && query.src) {
      utms.src = query.src;
    }
    if (typeof query.affiliate === 'string' && query.affiliate) {
      utms.affiliate = query.affiliate;
    }
    return {
      nome: this.cotacao.nome,
      email: this.email,
      ddd: this.cotacao.ddd,
      telefone: this.cotacao.telefone.replace(/\D/g, ''),
      placa: this.cotacao.placa,
      marca: this.cotacao.marca,
      modelo: this.cotacao.modelo,
      ano: this.cotacao.ano,
      combustivel: this.cotacao.combustivel,
      fipe_codigo: this.cotacao.fipe_codigo,
      valor_fipe: this.cotacao.valor_fipe,
      cobertura: this.cotacao.cobertura,
      valor_cobertura: this.cotacao.valor_cobertura,
      valor_adesao: this.cotacao.valor_adesao,
      valor_plano: this.$store.getters.valor_plano,
      valor_mensalidade: this.$store.getters.valor_mensalidade,
      indicador: this.$store.state.simulacao.indicador,
      cod_indicador: this.cotacao.cod_indicador,
      vendedor: this.cotacao.vendedor ?? 16482,
      original_origem: OriginalOrigem.get(),
      ...utms,
    };
  }

  public async onClick() {
    if ((this.$parent as VuetifyForm).validate()) {
      // Dados do usuário para a mensuração do GTM; não é conversão.
      DataLayer.push({
        event: 'proteauto_lead_submit',
        lead_email: this.email,
      });

      const dados = this.dados;
      const isNovoLead = this.$store.state.cotacao.id === 0;
      let leadCriado = false;
      let data;

      this.loadingCotacao = true;
      try {
        if (isNovoLead) {
          data = await Simulador.create(dados);
          this.$store.commit('SET_COTACAO_ID', data.id);
          this.$store.commit('SET_PROTOCOLO', data.protocolo);
          leadCriado = !!data.success && data.id > 0;
        } else {
          dados.id = this.$store.state.cotacao.id;
          data = await Simulador.update(dados);
        }
      } catch (error) {
        showErroCotacao(this, error);
        return;
      } finally {
        this.loadingCotacao = false;
      }

      this.$router.push({
        name: this.nextRoute,
        params: { arg: this.nextUrl },
        query: {
          ...this.$route.query,
          ...this.nextQuery,
        },
      });

      if (data.option) {
        // Veículos com FIPE <= 110 mil têm mensalidade fixa promocional
        // (state.configuracoes.abaixo_110); não sobrescrever com o valor
        // calculado por veículo.
        if (this.cotacao.valor_fipe > 110000) {
          this.$store.commit('SET_VALOR_MENSAL', data.option.monthly_value);
        }
        this.$store.commit('SET_VALOR_ADESAO', data.option.fee_value);
      }

      let identificador = 'Simulador site';

      if (this.cotacao.cod_indicador !== 0) {
        this.conversaoIndicador(data);
        identificador += ' Link de venda';
      }

      if (this.cotacao.vendedor === undefined) {
        this.conversaoPrincipal(identificador, data);

        if (this.cotacao.valor_fipe > 100000) {
          this.conversaoCaminhao();
        }
      }

      // Só quando o backend confirma a criação: um único disparo por lead.
      if (leadCriado) {
        DataLayer.push({ event: 'proteauto_lead_success' });
      }
    }
  }

  public conversaoIndicador(data: any) {
    Indicadores.createDeal({
      ...this.dados,
      id_proposta: data.id,
    }).then();
    RdStation.conversion({
      email: this.email,
      identificador: `Indicador APP`,
      codReferencia: this.cotacao.cod_indicador,
      nomeIndicador: this.$store.state.simulacao.indicador,
      id_proposta: this.cotacao.id,
      id_vendedor: this.cotacao.vendedor ?? 16482,
    });
  }

  public conversaoCaminhao() {
    RdStation.conversion({
      email: this.email,
      identificador: 'Caminhão Acima de 100mil',
      id_proposta: this.cotacao.id,
      id_vendedor: this.cotacao.vendedor ?? 16482,
    }).then();
  }

  public conversaoPrincipal(identificador: string, data: any) {

    const query = this.$route.query;
    const utms: { [key: string]: string } = {};
    const sendConversion = true; // process.env.NODE_ENV === 'production';

    if (typeof query.utm_source === 'string' && query.utm_source) {
      utms.utm_source = query.utm_source;
    }
    if (typeof query.utm_medium === 'string' && query.utm_medium) {
      utms.utm_medium = query.utm_medium;
    }
    if (typeof query.utm_campaign === 'string' && query.utm_campaign) {
      utms.utm_campaign = query.utm_campaign;
    }
    if (typeof query.utm_content === 'string' && query.utm_content) {
      utms.utm_content = query.utm_content;
    }
    if (typeof query.utm_term === 'string' && query.utm_term) {
      utms.utm_term = query.utm_term;
    }
    if (typeof query.fbclid === 'string' && query.fbclid) {
      utms.fbclid = query.fbclid;
    }
    if (typeof query.gclid === 'string' && query.gclid) {
      utms.gclid = query.gclid;
    }
    if (typeof query.fbc === 'string' && query.fbc) {
      utms.fbc = query.fbc;
    }
    if (typeof query.fbp === 'string' && query.fbp) {
      utms.fbp = query.fbp;
    }
    if (typeof query.src === 'string' && query.src) {
      utms.src = query.src;
    }
    if (typeof query.affiliate === 'string' && query.affiliate) {
      utms.affiliate = query.affiliate;
    }

    if (sendConversion) {

      const body: { [key: string]: any } = {
        "nome": this.cotacao.nome,
        "email": this.email,
        identificador,
        "telefone": this.dddTelefone,
        "celular": this.dddTelefone,
        'Tipo de veículo': 'Caminhão',
        "Marca": this.cotacao.marca,
        "Veículo": this.cotacao.modelo,
        "Modelo": this.$store.getters.veiculo_ano,
        'Preço do Veículo': this.cotacao.valor_fipe,
        'Mensalidade teto': this.$store.getters.valor_mensalidade,
        'Link proposta': `https://prote.me/${data.protocolo}`,
        "id_proposta": this.cotacao.id,
        "id_vendedor": this.cotacao.vendedor ?? 16482,
        ...utms,
      };

      RdStation.conversion(body).then();
    }
  }
}
